import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import { URL, APK_UPDATE_RESOURCES } from '../../helper';
import useService from '../../useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setShowLoader, setForceUpdateRows, setConfirmationDialog } = params;
	const { showAlert } = useContext(AppContext);
	const { requestDeployWebsiteUpdateInfo } = useService();

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.websiteUpdateInfo]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.websiteUpdateInfo]}/clone`,
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.websiteUpdateInfo]}/create`
				});
			};
		case 'deploy': {
			const toggleIsDisabled = async () => {
				setShowLoader(true);
				try {
					await requestDeployWebsiteUpdateInfo(rowData._id);
					showAlert('Bucket activated');
					setForceUpdateRows(true);
				} catch (err: any) {
					showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				}
				setShowLoader(false);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want to deploy this APK test on website?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
